// extracted by mini-css-extract-plugin
export default {"menu__mobile":"MenuMobile_menu__mobile__DL9eV","icon__close":"MenuMobile_icon__close__gQYvK"};